(() => {
  if (window.__cainOfferTrackingLoaded) return;
  window.__cainOfferTrackingLoaded = true;

  const emit = (payload) => {
    const detail = {
      event: 'cain_offer_interaction',
      offer: payload.offer || '',
      action: payload.action || 'click',
      product_handle: payload.productHandle || '',
      destination: payload.destination || '',
      path: window.location.pathname,
      timestamp: Date.now()
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    window.dispatchEvent(new CustomEvent('cain:offer', { detail }));
  };

  if (!window.customElements.get('cain-low-stock')) {
    window.customElements.define('cain-low-stock', class CainLowStock extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.getAttribute('form-id'));
        this.threshold = Number(this.getAttribute('threshold')) || 0;
        this.messageElement = this.querySelector('[data-stock-message]');

        try {
          this.variants = JSON.parse(this.querySelector('[data-stock-variants]')?.textContent || '[]');
        } catch (_) {
          this.variants = [];
        }

        this.onVariantChange = (event) => this.update(event.detail?.variant);
        this.form?.addEventListener('variant:change', this.onVariantChange);

        const selectedId = Number(this.form?.elements?.id?.value);
        this.update(this.variants.find((variant) => Number(variant.id) === selectedId));
      }

      disconnectedCallback() {
        this.form?.removeEventListener('variant:change', this.onVariantChange);
      }

      update(variant) {
        const quantity = Number(variant?.inventory_quantity);
        const shouldShow = Boolean(
          this.threshold > 0 &&
          variant?.available &&
          variant?.inventory_management &&
          variant?.inventory_policy === 'deny' &&
          quantity > 0 &&
          quantity <= this.threshold
        );

        this.hidden = !shouldShow;
        if (!shouldShow || !this.messageElement) return;

        const hasNamedVariant = variant.title && variant.title !== 'Default Title';
        const template = this.getAttribute(hasNamedVariant ? 'variant-message' : 'default-message') || '';
        this.messageElement.textContent = template
          .replace('[quantity]', String(quantity))
          .replace('[variant]', variant.title || '');
      }
    });
  }

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-cain-offer]');
    if (!target) return;
    emit({
      offer: target.dataset.cainOffer,
      action: target.dataset.cainAction || 'click',
      productHandle: target.dataset.cainProductHandle || '',
      destination: target.href || ''
    });
  }, { passive: true });
})();
